import { ObjectTypes } from './index';

export enum SiteMapDndType {
    Document = 'document',
    MediaBank = 'mediaBank',
    Tag = 'tag',
}

export const SiteMapDndTypeByObjectType: { [key in ObjectTypes]?: SiteMapDndType } = {
    [ObjectTypes.Document]: SiteMapDndType.Document,
    [ObjectTypes.MediaBank]: SiteMapDndType.MediaBank,
    [ObjectTypes.Tag]: SiteMapDndType.Tag,
};
